/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolFilterTool,
  ToolFilterTool$inboundSchema,
} from "./toolfiltertool.js";

/**
 * A filter tag ("scope") and the tools reachable when filtering by it via the runtime ?tags= parameter.
 */
export type ToolFilterScope = {
  /**
   * The filter tag
   */
  tag: string;
  /**
   * The number of tools under this scope
   */
  toolCount: number;
  /**
   * The tools under this scope
   */
  tools: Array<ToolFilterTool>;
};

/** @internal */
export const ToolFilterScope$inboundSchema: z.ZodMiniType<
  ToolFilterScope,
  unknown
> = z.pipe(
  z.object({
    tag: z.string(),
    tool_count: z.int(),
    tools: z.array(ToolFilterTool$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tool_count": "toolCount",
    });
  }),
);

export function toolFilterScopeFromJSON(
  jsonString: string,
): SafeParseResult<ToolFilterScope, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolFilterScope$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolFilterScope' from JSON`,
  );
}
